(function (factory) {
  'use strict';
  factory(jQuery);
}(function ($) {
  var delay_tab = 300,
    delay_show_mm = 300,
    delay_hide_mm = 300

  function mm_destroy(e, m) {
    m.remember_state || (e.find(".mmpanel").toggleClass("mmsubopened mmcurrent mmopened", !1).addClass("mmhidden"), e.find("#mm0").addClass("mmopened").addClass("mmcurrent").removeClass("mmhidden")), e.toggleClass("mmhide mmitemopen", !1).hide(), $("body").removeClass("mm-open")
  }

  function get_mm_parent() {
    return '<div class="mmpanels"></div>'
  }

  function get_mm_block() {
    return '<div class="mmpanel mmhidden">'
  }

  function getButtonBack(e, m) {
    return '<li><a href="#" data-target="#" class="mm-prev-level">' + (e = null == e ? m : e) + "</a></li>"
  }

  function getButtonClose(e, m) {
    return '<li class="mm-close-parent"><a href="#close" data-target="#close" class="mm-close">' + (e = null == e ? m : e) + "</a></li>"
  }

  function getFullscreenBg() {
    return '<div class="mm-fullscreen-bg"></div>'
  }

  $("body").append(getFullscreenBg())

  $.fn.check_resolution_mm = function (e) {
    var m = $(this)
    $(window).resize(function () {
      if (!$("body").hasClass("mm-open") || !m.hasClass("mmitemopen")) return !1
      window.innerWidth > e.mm_breakpoint && m.closemm(e)
    })
  }

  $.fn.mm_handler = function (e) {
    $(this).click(function (m) {
      m.preventDefault(), e.$mobilemenu.openmm()
    }), 0 != e.second_button && $(e.second_button).click(function (m) {
      m.preventDefault(), e.$mobilemenu.openmm()
    })
  }

  $.fn.parse_mm = function (e) {
    var m, n = $(this).clone(),
      t = $(get_mm_parent()),
      a = !1,
      s = 0,
      o = !1,
      i = !1

    $(this).empty(), n.find("a").each(function () {
      o = $(this), (m = o.parent().find("ul").first()).length && (s++ , m.prepend("<li></li>").find("li").first().append(o.clone().addClass("mm-original-link")), o.attr("href", "#mm" + s).attr("data-target", "#mm" + s).addClass("mm-next-level"))
    }), n.find("ul").each(function (m) {
      i = !1, a = $(get_mm_block()).attr("id", "mm" + m).append($(this)), 0 == m ? (a.addClass("mmopened").addClass("mmcurrent").removeClass("mmhidden"), i = getButtonClose(n.find(".mm-closebtn").html(), e.mm_close_button), a.find("ul").first().prepend(i)) : (i = getButtonBack(n.find(".mm-backbtn").html(), e.mm_back_button), a.find("ul").first().prepend(i)), t.append(a)
    }), $(this).append(t)
  }

  $.fn.init_mm = function (e) {
    var m = $(this)
    m.find("a").each(function () {
      $(this).click(function (n) {
        var t = $(this),
          a = !1,
          s = ""
        return t.hasClass("mm-next-level") ? (n.preventDefault(), s = t.attr("href"), (a = m.find(".mmcurrent")).addClass("mmsubopened").removeClass("mmcurrent"), m.find(s).removeClass("mmhidden"), setTimeout(function () {
          m.find(s).scrollTop(0).addClass("mmcurrent").addClass("mmopened")
        }, 0), setTimeout(function () {
          a.addClass("mmhidden")
        }, delay_tab), !1) : t.hasClass("mm-prev-level") ? (n.preventDefault(), s = t.attr("href"), (a = m.find(".mmcurrent")).removeClass("mmcurrent").removeClass("mmopened"), m.find(".mmsubopened").last().removeClass("mmhidden").scrollTop(0).removeClass("mmsubopened").addClass("mmcurrent"), setTimeout(function () {
          a.addClass("mmhidden")
        }, delay_tab), !1) : t.hasClass("mm-close") ? (m.closemm(e), !1) : void 0
      })
    }), $(".mm-fullscreen-bg").click(function (n) {
      n.preventDefault(), m.closemm(e)
    })
  }

  $.fn.openmm = function () {
    var e = $(this)
    e.show(), setTimeout(function () {
      $("body").addClass("mm-open"), e.addClass("mmitemopen"), $(".mm-fullscreen-bg").fadeIn(delay_show_mm)
    }, 0)
  }

  $.fn.closemm = function (e) {
    var m = $(this)
    m.addClass("mmhide"), $(".mm-fullscreen-bg").fadeOut(delay_hide_mm), setTimeout(function () {
      mm_destroy(m, e)
    }, delay_hide_mm)
  }

  return $.fn.initMM = function () {
    var e = {
      $mobilemenu: $(".panel-menu"),
      mm_close_button: "Close",
      mm_back_button: "Back",
      mm_breakpoint: 768,
      mm_enable_breakpoint: !1,
      mm_mobile_button: !1,
      remember_state: !1,
      second_button: !1,
      init: function (m, n) {
        var t = this
        if (!t.$mobilemenu.length) return console.log('You not have <nav class="panel-menu">menu</nav>. See Documentation'), !1
        null != arguments[1] && t.parse_arguments(n), t.$mobilemenu.parse_mm(e), t.$mobilemenu.init_mm(e), t.mm_enable_breakpoint && t.$mobilemenu.check_resolution_mm(e), m.mm_handler(e)
      },
      parse_arguments: function (e) {
        var m = this
        Object(e).hasOwnProperty("menu_class") && (m.$mobilemenu = $("." + e.menu_class)), $.each(e, function (e, n) {
          switch (e) {
            case "right":
              n && m.$mobilemenu.addClass("mm-right")
              break
            case "close_button_name":
              m.mm_close_button = n
              break
            case "back_button_name":
              m.mm_back_button = n
              break
            case "width":
              m.$mobilemenu.css("width", n)
              break
            case "breakpoint":
              m.mm_breakpoint = n
              break
            case "enable_breakpoint":
              m.mm_enable_breakpoint = n
              break
            case "mobile_button":
              m.mm_mobile_button = n
              break
            case "remember_state":
              m.remember_state = n
              break
            case "second_button":
              m.second_button = n
          }
        })
      },
      show_button_in_mobile: function (e) {
        var m = this
        m.mm_mobile_button && (window.innerWidth > m.mm_breakpoint ? e.hide() : e.show(), $(window).resize(function () {
          window.innerWidth > m.mm_breakpoint ? e.hide() : e.show()
        }))
      }
    }
    e.init($(this), arguments[0]), e.show_button_in_mobile($(this))
  }

}));
